var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            keepOpened: "",
            title:
              _vm.$t("appointmentCancel.cancel") + " " + _vm.appointmentType,
            okBtnText:
              _vm.$t("appointmentCancel.wantToCancel") +
              " (" +
              _vm.appointmentType +
              ")",
            okBtnVariant: "danger",
            cancelBtnText: _vm.$t("back"),
            cancelBtnVariant: "secondary",
            okFn: function() {
              _vm.cancelConsultation()
            },
            cancelFn: function() {
              _vm.$emit("toggleCancelAppointment")
            }
          },
          model: {
            value: _vm.showDialog,
            callback: function($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog"
          }
        },
        [
          [
            _vm.appointmentDetails.patientData
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      {
                        attrs: {
                          cols: "12",
                          xs: "12",
                          md: "6",
                          lg: "6",
                          xl: "6"
                        }
                      },
                      [
                        _c("b-row", [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("appointmentCancel.patientData"))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "align-items-center" },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "5", xs: "5" } },
                              [
                                _c("b-row", [
                                  _c("img", {
                                    staticClass: "details-photo",
                                    attrs: {
                                      src:
                                        _vm.appointmentDetails.patientData
                                          .photo,
                                      alt: ""
                                    }
                                  })
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "details-container",
                                attrs: { cols: "7", xs: "7" }
                              },
                              [
                                _c("b-row", [
                                  _c("p", { staticClass: "details-name" }, [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.appointmentDetails.patientData
                                            .fullName
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData
                                          .fullAddress
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData.email
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appointmentDetails.patientData
                                          .phonenumber
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "appointment-container",
                        attrs: {
                          cols: "12",
                          xs: "12",
                          md: "6",
                          lg: "6",
                          xl: "6"
                        }
                      },
                      [
                        _c("b-row", [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("appointmentCancel.appointmentSummary")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("date") + ":"))
                                    ]),
                                    _vm._v(
                                      " " + _vm._s(_vm.formattedAppointmentDate)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.appointmentDetails.duration
                                  ? _c("b-row", [
                                      _c("p", { staticClass: "details-text" }, [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.$t("duration") + ":")
                                          )
                                        ]),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.appointmentDetails.duration
                                            )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c("p", { staticClass: "details-text" }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.$t("price") + ":"))
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.appointmentDetails.price) +
                                        " " +
                                        _vm._s(_vm.currency)
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "reason-container" },
              [
                _c("b-row", [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("appointmentCancel.cancelationReason"))
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("base-textarea", {
                  staticClass: "message-text mt-2",
                  attrs: {
                    rows: 1,
                    "max-rows": 5,
                    placeholder: _vm.$t("appointmentCancel.writeAReason")
                  },
                  model: {
                    value: _vm.cancelReason,
                    callback: function($$v) {
                      _vm.cancelReason = $$v
                    },
                    expression: "cancelReason"
                  }
                })
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ef8b480", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ef8b480","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/shared/CancelAppointmentModal.vue
// module id = 4084
// module chunks = 14